import { render, staticRenderFns } from "./S406.vue?vue&type=template&id=35dd217e&scoped=true"
import script from "./S406.vue?vue&type=script&lang=js"
export * from "./S406.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=35dd217e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd217e",
  null
  
)

export default component.exports